import React, { useEffect } from "react";
import { useState } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import { Popup } from "semantic-ui-react";
import axios from "../../../../axios";
import ResolveQueryLib from "./resolveQueryLib";
import NestedReply from "../../../../Engagement/StudentQuery/Reply Query/NestedReply";
import moment from "moment";
import EditReply from "../../../../Engagement/StudentQuery/Reply Query/ThreeDot_Edit _Delete/EditReply";
import EditReplyLib from "./EditReply";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import DeleteQueryLib from "./DeleteQueryLib";
import CreateBookMarkPopup from "./CreateBookMarkPopup";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
export default function Query({
  book,
  chapter,
  userDetail,
  bookId,
  chapterId,
  grpId1,
  setEditQuery2,
  setIsUpdate1,
  componentRerenderFlag,
  setComponentRerenderFlag,
}) {
  const [showReply, setShowReply] = useState([]);
  const [editQuery, setEditQuery] = useState(false);
  const [deleteQuery, setDeleteQuery] = useState(false);
  const [replyQuery, setReplyQuery] = useState(false);
  const [allQuery, setAllQuery] = useState([]);
  const [clickedQuery, setClickedQuery] = useState(false);
  const [markQuery, setMarkQuery] = useState(false);
  const [reply, setReply] = useState([]);
  const [forReply, setForReply] = useState();
  const [userReplu, setUserReply] = useState();
  const [errorMsg, setErrorMsg] = useState("")
  const [viewErrorPop, setViewErrorPop] = useState(false)
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });

  useEffect(() => {
    try {
      const helper = async () => {
        try {
          setAllQuery([]);
          let res = await axios.get(
            `/query/getForStudent/${userDetail?.id}/groupId/${grpId1}?chapterId=${chapterId}&bookId=${bookId?.id}`
            // `/query/getForStudent/638dee5fc4d6787791bfa3b2/groupId/63d170e85a7846485630cb01?chapterId=633c5b3a629a3af66952fa5d&bookId=633c5ac7629a3af66952fa5c`
          );
          setAllQuery(res.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      if (grpId1 !== undefined) {
        helper();
      }
    } catch (error) {
      console.log(error);
    }
  }, [grpId1, componentRerenderFlag]);
  function getTimeAMPM(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours}:${minutes < 10 ? "0" : ""
      }${minutes} ${ampm}`;
    return formattedTime;
  }
  const [likedReplies, setLikedReplies] = useState([]);
  const [likeCounts, setLikeCounts] = useState([]);
  useEffect(() => {
    const initialLikedReplies = reply.map((obj) =>
      obj.likes.includes(userDetail.id)
    );
    setLikedReplies(initialLikedReplies);
    const initialLikeCounts = reply.map((obj) => obj.likes.length);
    setLikeCounts(initialLikeCounts);
  }, [reply, userDetail.id]);

  const toggleReply = (index) => {
    const newShowReply = Array.from(
      { length: allQuery.length },
      (_, i) => i === index
    );
    setShowReply(newShowReply);
  };
  useEffect(() => {
    try {
      if (clickedQuery?.id) {
        const handleReply = async () => {
          let res = await axios.get(`/query/reply/get/${clickedQuery?.id}`);
          setReply(res.data.data);
        };
        handleReply();
      }
    } catch (error) {
      console.log(error)
      if (error) {
        setErrorMsg(error.response.data.message)
        setViewErrorPop(true)
      }
    }
  }, [clickedQuery]);
  function getFirstCharacterOfFirstName(fullName) {
    const nameParts = fullName.trim().split(" ");
    if (nameParts.length > 0) {
      const firstName = nameParts[0];
      return firstName.charAt(0).toUpperCase();
    } else {
      return "N/A";
    }
  }
  const handleLikeClick = (index) => {
    const newLikedReplies = [...likedReplies];
    const newLikeCounts = [...likeCounts];
    newLikedReplies[index] = !newLikedReplies[index];
    if (newLikedReplies[index]) {
      newLikeCounts[index]++;
      axios
        .put(`/query/reply/like/${reply[index].id}`, {
          user_id: userDetail?.id,
        })
        .then((res) => {
          console.log(res);
        });
    } else {
      newLikeCounts[index]--;
    }
    setLikedReplies(newLikedReplies);
    setLikeCounts(newLikeCounts);
  };
  const [deletedReplies, setDeletedReplies] = useState(
    new Array(reply.length).fill(false)
  );
  const handleDeleteReply = (index) => {
    const updatedDeletedReplies = [...deletedReplies];
    updatedDeletedReplies[index] = true;
    setDeletedReplies(updatedDeletedReplies);
  };
  const delteLogic = async (index) => {
    let user_id = userDetail?.id;
    let res = await axios.delete(`/query/reply/delete/${reply[index].id}`, {
      data: { user_id },
    });
    console.log(res);
  };
  const [replycreate, setReplycreate] = useState("");
  const handleFetchQuery = async () => {
    let res = await axios.get(`/query/reply/get/${clickedQuery?.id}`);
    setReply(res.data.data);
  };
  const handleCreateReply = async () => {
    try {
      let body = {
        user_id: userDetail.id,
        reply: replycreate,
        attachments: [],
      };
      let res = await axios.post(
        `/query/${clickedQuery.id}/reply/create`,
        body
      );
      if (res.status === 201) {
        setReplycreate("");
        handleFetchQuery();
      }
    } catch (error) { }
  };
  const handleParentReply = async () => {
    let body = {
      user_id: userDetail.id,
      reply: replycreate,
      attachments: [],
    };
    let res = await axios.post(
      `/query/${clickedQuery.id}/${userReplu.id}/reply/create`,
      body
    );
    if (res.status === 201) {
      setReplycreate("");
      handleFetchQuery();
      setReplyQuery(false);
    }
  };
  const formatCreatedAt = (createdAt) => {
    return moment(createdAt).calendar({
      sameDay: "h:mm A",
      lastDay: "[Yesterday]",
      lastWeek: "DD MMM YYYY",
      sameElse: "DD MMM YYYY",
    });
  };
  const [editReplyIndex, setEditReplyIndex] = useState(-1);
  const [edit, setEdit] = useState();
  const [editQuery1, setEditQuery1] = useState();
  useEffect(() => {
    setEditQuery1(editQuery1);
  }, [editQuery1]);


  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment)
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };

  return (
    allQuery.length > 0 &&
    allQuery.map((obj, index) => (
      <div className="TotalQuerResponseConatiner p-3 mt-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-3 align-items-center ">
            <div>
              {obj.status === "resolved" && (
                <img src="/LibraryImg/ResolvedTag.png" alt="" />
              )}
              {obj.status === "approved" && (
                <img src="/LibraryImg/ActiveQuery.png" alt="" />
              )}
              {obj.status === "pending" && (
                <img src="/images/Pending.svg" alt="" style={{ width: "60px" }} />
              )}
              {obj.status === "rejected" && (
                <img src="/images/Rejected.svg" alt="" style={{ width: "60px" }} />
              )}
            </div>
            {/* <div>
                  <img src="/LibraryImg/PendingQurey.png" alt="" />
              </div> */}
            <div className="QueryChapterName">
              {book} <IoChevronForwardOutline /> {chapter}
            </div>
            <div className="d-flex gap-2">
              {obj.tags.map((tag) => (
                <div
                  style={{
                    padding: "5px",
                    backgroundColor: "#CCD6DD",
                    color: "#000A11",
                    borderRadius: "8px"
                  }}
                >
                  {tag}
                </div>
              ))}
            </div>
          </div>
          {(obj.status === "resolved" || obj.status === "approved") && (
            <div className="d-flex gap-3 align-items-center">
              {obj.tags.length > 0 &&
                obj.tags.map((obj) => (
                  <div className="ChatperQueryBtn">{obj}</div>
                ))}
              <div
                onClick={() => {
                  toggleReply(index);
                  setClickedQuery(obj);
                }}
              >
                {showReply[index] ? (
                  <img src="/LibraryImg/UpwordArrow.svg" alt="" />
                ) : (
                  <img src="/LibraryImg/downArrow.svg" alt="" />
                )}
              </div>
            </div>
          )}
        </div>

        <div className="mt-3 ">
          <div>
            <div className="d-flex gap-3">
              <div className="schoolQuryName">{obj.query}</div>
              <div className="repliesCount">{obj.reply_count} replies</div>
              <div className="repliesTime">{getTimeAMPM(obj.updated_at)}</div>
              {
                obj?.user_id?.role === "Teacher" ?
                  <img
                    src={
                      obj?.user_id?.profile_picture
                        ? IP + obj?.user_id?.profile_picture.replace(/^\./, "")
                        : obj?.user_id?.gender === "M"
                          ? "/images/Teacher_Male.jpg"
                          : obj?.user_id?.gender === "F"
                            ? "/images/Teacher_Female.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    className=""
                    style={{ width: "26px", height: "26px", borderRadius: "50%", cursor: "pointer" }}
                    key={obj?.user_id?.avatarProfile}
                    onError={(e) => {
                      if (obj?.user_id?.gender === "M") {
                        e.target.src = "/images/Teacher_Male.jpg"
                      } else if (obj?.user_id?.gender === "F") {
                        e.target.src = "/images/Teacher_Female.png"
                      } else {
                        e.target.src = "/images/default image.png"
                      }
                    }}
                  /> : <img
                    src={
                      obj?.user_id?.profile_picture
                        ? IP + obj?.user_id?.profile_picture.replace(/^\./, "")
                        : obj?.user_id.gender === "M"
                          ? obj?.user_id?.avatarProfile ? '/images/Boys/' + obj?.user_id?.avatarProfile + '.webp'
                            : "/images/Student_boy_pic.png"
                          : obj?.user_id?.gender === "F"
                            ? obj?.user_id?.avatarProfile ? '/images/Girls/' + obj?.user_id?.avatarProfile + '.webp'
                              : "/images/Student_girl_pic.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    className=""
                    style={{ width: "26px", height: "26px", borderRadius: "50%", cursor: "pointer" }}
                    key={obj?.user_id?.avatarProfile}
                    onError={(e) => {
                      e.target.src = obj?.user_id?.avatarProfile ? '/images/Girls/' + obj?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                      if (obj?.user_id?.gender === "M") {
                        e.target.src = obj?.user_id?.avatarProfile ? '/images/Boys/' + obj?.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                      } else if (obj?.user_id?.gender === "F") {
                        e.target.src = obj?.user_id?.avatarProfile ? '/images/Girls/' + obj?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                      } else {
                        e.target.src = "/images/default image.png"
                      }
                    }}
                  />
              }
              <div className="YouTag">
                {obj.user_id.id === userDetail.id ? "You" : obj.user_id.name}
              </div>
              {obj.status === "approved" && (
                <span
                  className="query_resolved"
                  name="resolved"
                  onClick={(e) => {
                    setMarkQuery(true);
                    setClickedQuery(obj);
                  }}
                >
                  Mark as Resolved
                </span>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div className="QueryType mt-2">
              {obj.description}
              <div className="mb-2 d-flex flex-wrap ">
                {obj.attachments.length > 0 &&
                  obj.attachments.map((attachment, index) => (
                    // <a
                    //   key={index}
                    //   href={IP + item?.substring(item?.indexOf("/"))}
                    //   download
                    //   className="link"
                    // >
                    //   <div className="p-1 mr-2  d-flex align-items-center attach_box">
                    //     <img
                    //       src={`${iconData?.find(
                    //         (i) => i.extension === item?.split(".")[1]
                    //       )?.icon
                    //         }`}
                    //       alt=""
                    //     />
                    //     &nbsp;&nbsp;
                    //     {item?.indexOf("_") > 0
                    //       ? item?.substring(item?.indexOf("_") + 1)
                    //       : item}
                    //     &nbsp;
                    //     <span className="attach_file_size me-2"> (40 kb)</span>
                    //     <img src="/images/download icon.svg" alt="" />
                    //   </div>
                    // </a>
                    <div key={index}>
                      {attachment.split(".").pop() !== "mp4" ? (
                        <>
                          {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment.split(".").pop() === "JPEG" ||
                            attachment.split(".").pop() === "JPG" ||
                            attachment.split(".").pop() === "PNG" ||
                            attachment.split(".").pop() === "png" ? (
                            <img
                              style={{ cursor: "pointer" }}
                              className="mt-3 imageWidthAndHeight_queryattach"
                              src={IP + attachment?.replace(/^\./, "")}
                              alt="Attachment"
                              onClick={() => {
                                if (!isError) {
                                  handleClick(attachment);
                                }
                              }}
                            />
                          ) : (
                            <div
                              key={index}
                              onClick={(e) =>
                                setPedingSubDetail({
                                  ...pedingSubDetail,
                                  pdfView: true,
                                })
                              }
                              className="mt-2"
                            >
                              <div className="d-flex pdfContainer gap-2 p-2" onClick={() => handleClickforpdf(attachment)}>
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment.substring(attachment.lastIndexOf(".") + 1)
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div className="pdfName">
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  <div className="pdfFileSize"></div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="d-flex pdfContainer gap-2 p-2 " onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}>
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div className="w-100">
                            <div className="pdfName">
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {(obj.status === "pending" || obj.status === "rejected") && (
            <div
              style={{ marginRight: "2.5rem" }}
              className=" d-flex justify-content-end"
            >
              <div
                className="mr-2 edit_query_box"
                onClick={(e) => {
                  setEditQuery2(obj);
                  setIsUpdate1(true);
                }}
              >
                <img src="/images/PenIcon.svg" alt="delete icon" />
                <span className="edit_query"> Edit Query </span>
              </div>
              <div
                className="delete_query_box"
                onClick={(e) => {
                  setDeleteQuery(true);
                  setClickedQuery(obj);
                }}
              >
                <img src="/images/delete white icon.svg" alt="delete icon" />
                <span className="delete_query"> Delete Query </span>
              </div>
            </div>
          )}
        </div>
        {(obj.status === "approved" || obj.status === "resolved") && (
          <div className="horizontalLine_Container mt-4">
            <span className="horizontalLine_text">
              {obj.reply_count} replies
            </span>
          </div>
        )}
        {/* active query  */}
        {showReply[index] && (
          <>
            {reply.length > 0 &&
              reply.map((object, index) => (
                <div>
                  {/* John detail  */}
                  <div
                    className={
                      editReplyIndex === index
                        ? " QuerySubContainerEdit p-1"
                        : ""
                    }
                  >
                    <div
                      className={deleteQuery ? " QuerySubContainer p-1" : ""}
                    >
                      <>
                        <div className="d-flex justify-content-between mt-4 ">
                          <div className="d-flex gap-2 ">
                            <div className="FirstLetter">
                              {getFirstCharacterOfFirstName(
                                object.user_id.name
                              )}
                            </div>
                            <div className="NameRepliers">
                              {object.user_id.name}
                            </div>
                            <div className="repliesTime">
                              {formatCreatedAt(object.created_at)}
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="d-flex align-items-center"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                obj.status === "approved" &&
                                  setReplyQuery(true);
                                setForReply(object.reply);
                                setUserReply(object);
                              }}
                            >
                              <img
                                src="/LibraryImg/Replie.png"
                                alt="replie icon"
                              />
                            </div>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                obj.status === "approved" &&
                                  setReplyQuery(true);
                                setForReply(object.reply);
                                setUserReply(object);
                              }}
                            >
                              Reply
                            </span>
                            <div
                              className="d-flex align-items-center"
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={
                                  likedReplies[index]
                                    ? "/LibraryImg/LikeQuery.png"
                                    : "/LibraryImg/Unlike.png"
                                }
                                alt={
                                  likedReplies[index]
                                    ? "Liked icon"
                                    : "Unlike icon"
                                }
                              />
                            </div>
                            <span
                              onClick={() => {
                                if (obj.status === "approved") {
                                  const newLikedStatus = [...likedReplies];
                                  newLikedStatus[index] = !likedReplies[index];
                                  setLikedReplies(newLikedStatus);
                                  handleLikeClick(index);
                                }
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Like
                            </span>
                            <span className="likeCount">
                              {likeCounts[index]}
                            </span>

                            <Popup
                              on="click"
                              className="popUpFilter"
                              trigger={
                                <div className="d-flex align-items-center ">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    src="/LibraryImg/HorizontalThreedot.png"
                                    alt="three dot"
                                  />
                                </div>
                              }
                              content={
                                obj.status === "approved" && (
                                  <div className="container_threedot p-3">
                                    <div
                                      className="PopupThreedots p-2"
                                      onClick={() => {
                                        setEditQuery(true);
                                        setEditReplyIndex(index);
                                        setEdit(object);
                                      }}
                                    >
                                      Edit
                                    </div>
                                    <div
                                      className="PopupThreedots p-2"
                                      onClick={() => {
                                        handleDeleteReply(index);
                                        delteLogic(index);
                                      }}
                                    >
                                      Delete
                                    </div>
                                  </div>
                                )
                              }
                            />
                          </div>
                        </div>
                        {deletedReplies[index] ? (
                          <div className="QueryMsgDelete ml-4 pl-2 mt-1">
                            You can no longer see this message
                          </div>
                        ) : (
                          <div>
                            <div className="d-flex  highlight_section mt-2 gap-3">
                              <div className="parentReply">
                                {object.parent_reply_id && (
                                  <div>
                                    <NestedReply
                                      parentReply={object.parent_reply_id}
                                    />
                                  </div>
                                )}
                                {editReplyIndex === index ? (
                                  <>
                                    <EditReplyLib
                                      // setEdited={setEdited}
                                      reply={edit}
                                      setReply={setEdit}
                                      setClickEditReply={() => {
                                        setEditReplyIndex(-1);
                                      }}
                                      userDetails={userDetail}
                                      refetch={handleFetchQuery}
                                    />
                                  </>
                                ) : (
                                  <p className="col-8 mb-2 p-0 show_reply_contain ml-5">
                                    {object.reply}
                                  </p>
                                )}
                                <div className="mb-2 d-flex flex-wrap ">
                                  {object.attachments.length > 0 &&
                                    object.attachments.map((attachment, index) => (
                                      // <a
                                      //   key={index}
                                      //   href={
                                      //     IP +
                                      //     item?.data?.substring(
                                      //       item.data.indexOf("/")
                                      //     )
                                      //   }
                                      //   download
                                      //   className="link"
                                      // >
                                      //   <div className="p-1 mr-2  d-flex align-items-center attach_box">
                                      //     <img
                                      //       src={`${iconData?.find(
                                      //         (i) =>
                                      //           i.extension ===
                                      //           item?.data?.split(".")[1]
                                      //       )?.icon
                                      //         }`}
                                      //       alt=""
                                      //     />
                                      //     &nbsp;&nbsp;
                                      //     {item?.data?.indexOf("_") > 0
                                      //       ? item.data.substring(
                                      //         item?.data?.indexOf("_") + 1
                                      //       )
                                      //       : item?.data}
                                      //     &nbsp;
                                      //     <span className="attach_file_size me-2">
                                      //       {" "}
                                      //       (40 kb)
                                      //     </span>
                                      //     <img
                                      //       src="/images/download icon.svg"
                                      //       alt=""
                                      //     />
                                      //   </div>
                                      // </a>
                                      <div key={index}>
                                        {attachment.split(".").pop() !== "mp4" ? (
                                          <>
                                            {attachment.split(".").pop() === "jpg" ||
                                              attachment.split(".").pop() === "jpeg" ||
                                              attachment.split(".").pop() === "JPEG" ||
                                              attachment.split(".").pop() === "JPG" ||
                                              attachment.split(".").pop() === "PNG" ||
                                              attachment.split(".").pop() === "png" ? (
                                              <img
                                                style={{ cursor: "pointer" }}
                                                className="mt-3 imageWidthAndHeight_queryattach"
                                                src={IP + attachment?.replace(/^\./, "")}
                                                alt="Attachment"
                                                onClick={() => {
                                                  if (!isError) {
                                                    handleClick(attachment);
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <div
                                                key={index}
                                                onClick={(e) =>
                                                  setPedingSubDetail({
                                                    ...pedingSubDetail,
                                                    pdfView: true,
                                                  })
                                                }
                                                className="mt-2"
                                              >
                                                <div className="d-flex pdfContainer gap-2 p-2" onClick={() => handleClickforpdf(attachment)}>
                                                  <div className="d-flex align-items-center">
                                                    <img
                                                      className="extention_icon"
                                                      src={`${iconData?.find(
                                                        (i) =>
                                                          i.extension ===
                                                          attachment.substring(attachment.lastIndexOf(".") + 1)
                                                      )?.icon
                                                        }`}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="w-100">
                                                    <div className="pdfName">
                                                      {attachment?.replace(/^[^_]*_/, "")}
                                                    </div>
                                                    <div className="pdfFileSize"></div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          <div className="d-flex pdfContainer gap-2 p-2 " onClick={() => {
                                            if (!isError) {
                                              handleClick(attachment);
                                            }
                                          }}>
                                            <div className="d-flex align-items-center">
                                              <img
                                                className="extention_icon"
                                                src={`${iconData?.find(
                                                  (i) =>
                                                    i.extension ===
                                                    attachment?.match(/\.([^.]+)$/)[1]
                                                )?.icon
                                                  }`}
                                                alt=""
                                              />
                                            </div>
                                            <div className="w-100">
                                              <div className="pdfName">
                                                {attachment?.replace(/^[^_]*_/, "")}
                                              </div>
                                              <div className="pdfFileSize"></div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              ))}
            <div className="ToatalContainerQueryInputs p-2 mt-3">
              {replyQuery && (
                <div className="ReplayContainerName p-2 mb-2">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-2">
                      <div className="FirstLetter">
                        {getFirstCharacterOfFirstName(userReplu.user_id.name)}
                      </div>
                      <div className="NameRepliers">
                        {userReplu.user_id.name}
                      </div>
                      <div className="repliesTime">
                        {formatCreatedAt(userReplu.created_at)}
                      </div>
                    </div>
                    <div>
                      <img
                        onClick={(e) => {
                          setReplyQuery(false);
                        }}
                        style={{ cursor: "pointer" }}
                        src="/LibraryImg/crossIconQuery.png"
                        alt="crossIconQuery icon"
                      />
                    </div>
                  </div>
                  <div className=" ml-4 pl-2 mt-1">{forReply}</div>
                </div>
              )}

              <div className="d-flex align-items-center justify-content-between gap-4">
                <div className="inputQuerySubContainer">
                  <input
                    className="queryInput"
                    placeholder="Type message"
                    disabled={obj.status === "approved" ? false : true}
                    value={replycreate}
                    maxLength={250}
                    onChange={(e) => {
                      setReplycreate(e.target.value);
                    }}
                  />
                </div>
                {obj.status === "approved" && (
                  <div className="mr-3">
                    <img
                      style={{ cursor: "pointer" }}
                      src="/LibraryImg/send.png"
                      alt="send icon"
                      onClick={() => {
                        replyQuery ? handleParentReply() : handleCreateReply();
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
        {pedingSubDetail.pdfView && (
          <PdfViewer
            handleRemovePdfVivwer={handleRemovePdfVivwer}
            attachment={responseAttach}
          />
        )}
        {isClicked &&
          (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                <video className="videoPlayer" controls>
                  <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                </video>
                <div>
                  <img
                    className="crossIconImgQue"
                    onClick={handleClick}
                    src="/DCM-img/crossIcon.svg"
                    alt="Up Arrow"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                {
                  !isError ? (
                    <>
                      <img
                        className="imgMain"
                        src={IP + responseAttach?.replace(/^\./, "")}
                        alt="Full-size"
                        onError={(e) => {
                          setIsError(true)
                        }}
                      />
                      <div>
                        <img
                          className="crossIconImgQue"
                          onClick={handleClick}
                          src="/images/cross.png"
                          alt="Up Arrow"
                        />
                      </div>
                    </>
                  ) : (
                    <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                      <img
                        onClick={() => {
                          setIsError(false)
                          handleClick()
                        }}
                        src="/images/cross.png"
                        alt="Up Arrow"
                        style={{ position: "absolute", top: "75px", right: "40%" }}
                      />
                      <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                      <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                    </div>
                  )
                }
              </div>
            </div>
          ))}
        {deleteQuery && (
          <DeleteQueryLib
            setDeleteQuery1={() => {
              setDeleteQuery();
            }}
            setComponentRerenderFlag={setComponentRerenderFlag}
            queryId={clickedQuery.id}
            userId={userDetail.id}
          />
        )}
        {markQuery && (
          <ResolveQueryLib
            close={() => {
              setMarkQuery(false);
            }}
            data={clickedQuery}
          />
        )}
        {
          viewErrorPop && (
            <CreateBookMarkPopup setViewErrorPop={setViewErrorPop} errorMsg={errorMsg} />
          )
        }
      </div>
    ))
  );
}
